/* unplugin-vue-components disabled */import { render } from "./detail.vue?vue&type=template&id=3ef0793d&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=3ef0793d&scoped=true&lang=scss"
import "./detail.vue?vue&type=style&index=1&id=3ef0793d&lang=css"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef0793d"]])

export default __exports__